import SimplePeer from "simple-peer";
import React, { useRef, useCallback, useState, useEffect } from "react";
import { InputGroup } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import useWebSocket from 'react-use-websocket';

const StreamReceiveComponent = () => {

  const [pc_sub, setpc_sub] = useState(null);

	const getWsUrl = useCallback(() => {
		return new Promise((resolve) => {
			setTimeout(()=>{document.getElementById('confirmBtn').onclick = () => {
				resolve(document.getElementById('signalServer').value);
			}}, 500)
			
		})
	}, []);
	const { sendMessage, lastMessage, lastJsonMessage, readyState } = useWebSocket(getWsUrl, {
		onOpen: () => console.log('opened ws'),
		shouldReconnect: () => true,
	});

	useEffect(()=>{
		if (!pc_sub) return;
		let msg = lastJsonMessage;
		switch (msg.type) {
		  case "start":
			break;
  
		  case "offer":
			pc_sub.setRemoteDescription(msg).then(() => {
			  pc_sub.createAnswer().then((answer) => {
				pc_sub.setLocalDescription(answer).then(() => {
					sendMessage(JSON.stringify(answer));
				}).catch((err) => {
  
				})
			  }).catch((err) => {
				console.error('create answer error', err);
			  })
			}).catch((err) => {
			  console.error('setRemoteDescription error', err);
			})
			break;
  
		  default:
			pc_sub.addIceCandidate(msg);
			break;
		}
	}, [lastJsonMessage])

	const start = async () => {
		if (readyState !== 1) return;
		const p = new RTCPeerConnection();
		setpc_sub(p);
		sendMessage(JSON.stringify({
				type: "subscribe"
			  }))

			  p.addEventListener('icecandidate', (event) => {
				if (event.candidate) {
					sendMessage(JSON.stringify(event.candidate));
				}
			  })
		  
			  p.addEventListener('track', (event) => {
				document.getElementById('receiveAudio').srcObject = event.streams[0];
			  })
		  
	};

  return (
    <>
      <div style={{textAlign:"center"}}>
				<InputGroup size="sm" style={{ padding: "2px" }}>
					<InputGroup.Text>Signal server</InputGroup.Text>
					<Form.Control id="signalServer" defaultValue='ws://127.0.0.1:9999' />
				</InputGroup>

        <Button
          variant={"secondary"}
          style={{ display: "block", margin: 2 + "px" }}
					id='confirmBtn'
        >
          Confirm
        </Button>
        <Button
          variant={"secondary"}
          style={{ display: "block", margin: 2 + "px" }}
          onClick={start}
					id='receiveAudioBtn'
        >
          Receive
        </Button>
				<audio id='receiveAudio' controls />
      </div>

    </>
  );
};

export default StreamReceiveComponent;
